import { EntityEnums } from "../enums";

export const certaintyDict = [
  {
    value: EntityEnums.Certainty.Empty,
    label: "-",
    info: "",
  },
  {
    value: EntityEnums.Certainty.Certain,
    label: "certain",
    info: "",
  },
  {
    value: EntityEnums.Certainty.AlmostCertain,
    label: "almost certain",
    info: "",
  },
  {
    value: EntityEnums.Certainty.Probable,
    label: "probable",
    info: "",
  },
  {
    value: EntityEnums.Certainty.Possible,
    label: "possible",
    info: "",
  },
  {
    value: EntityEnums.Certainty.Dubious,
    label: "dubious",
    info: "",
  },
  {
    value: EntityEnums.Certainty.False,
    label: "false",
    info: "",
  },
];
